<template>
  <div v-if="formData.type === 'marketplace'" class="px-3">
    <div class="w-full bg-white rounded-lg border border-slate-200">
      <!-- Header Section -->
      <div class="flex items-center p-6 border-b border-slate-200">
        <div class="flex w-full items-center">
          <button
            class="bg-primary rounded-full flex justify-center items-center w-10 h-10 mr-3 text-white"
            @click="RouterBack()"
          >
            <Icon icon="mdi:chevron-left" class="text-3xl" />
          </button>
          <h1 class="text-xl font-bold text-primary">Produit details</h1>
        </div>
      </div>

      <!-- Product Detail Section -->
      <div id="detail" class="px-6 py-4">
        <div class="flex items-start">
          <span
            class="flex-shrink-0 rounded-full h-12 w-12 bg-slate-100 flex items-center justify-center"
          >
            <Icon icon="ic:round-line-weight" class="text-2xl text-primary" />
          </span>

          <div class="ml-5 w-full">
            <div class="text-base font-semibold text-slate-700 uppercase mb-4">
              {{ formData.name }}
            </div>

            <div class="flex flex-col md:flex-row md:gap-10">
              <img
                class="w-full md:w-96 h-auto rounded-lg overflow-hidden object-cover mb-6 md:mb-0"
                :src="formData.picture"
                :alt="formData.name"
              />

              <div class="flex flex-col gap-4">
                <span
                  class="text-xl font-bold text-slate-900 dark:text-white uppercase"
                >
                  {{ formData.name }}
                </span>

                <div v-if="formData.verificationLink">
                  <a
                    :href="formData.verificationLink"
                    target="_blank"
                    class="group relative inline-flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-primary to-blue-300 text-white font-medium rounded-[6px] transition-all duration-300 transform hover:translate-y-[-2px] hover:shadow-base overflow-hidden"
                  >
                    <span
                      class="relative z-10 text-base font-semibold tracking-wide"
                      >Produit page</span
                    >
                    <span
                      class="relative z-10 flex items-center justify-center w-7 h-7 rounded-full bg-white/20 backdrop-blur-sm group-hover:bg-white/30 transition-all duration-300 group-hover:rotate-12"
                    >
                      <Icon
                        icon="mdi:arrow-top-right-bold"
                        class="text-white text-lg group-hover:scale-110 transition-transform duration-300"
                      />
                    </span>
                    <span
                      class="absolute inset-0 w-full h-full bg-gradient-to-r from-primary/0 via-white/10 to-primary/0 transform translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"
                    ></span>
                  </a>
                </div>

                <div class="flex items-center">
                  <span class="font-bold mr-2">Country:</span>
                  <div class="flex space-x-1">
                    <span
                      v-for="(detialPr, r) in $f.removeCountryByTwoArray(
                        formData.details,
                        currentUser.countries
                      )"
                      :key="r"
                    >
                      <img
                        :src="
                          'https://static.dwcdn.net/css/flag-icons/flags/4x3/' +
                          detialPr.country.toLowerCase() +
                          '.svg'
                        "
                        class="w-5 h-5 rounded-full"
                        :alt="detialPr.country"
                      />
                    </span>
                  </div>
                </div>

                <!-- <div class="flex items-center">
                  <span class="font-bold text-xl text-primary">
                    <span>≃</span>
                    {{ getPrice(formData.details)}} CFA
                  </span>
                </div> -->

                <div class="space-y-1 w-full mr-1"> 
                      <div
                        v-for="(group, index) in getPrice(formData.details)"
                        :key="index"
                        class="flex items-center justify-between border p-1 rounded-lg bg-gray-50"
                      >
                        <div class="flex items-center gap-1 flex-wrap"> 
                          <span
                            v-for="country in group.countries"
                            :key="country.country"
                            class="text-sm pr-1"
                            :title="country.country"
                          >
                            <img class="w-4 h-4 rounded-full inline-block border border-white" :src="'https://static.dwcdn.net/css/flag-icons/flags/4x3/' +country.country.toLowerCase() +'.svg'"/>
                          </span>
                        </div>
                        <span class="text-teal-600 font-semibold">
                          {{ group.priceMarket }} CFA
                        </span>
                      </div>
                    </div>

                <div>
                  <div
                    v-if="
                      currentUser.type === 'Seller' &&
                      (!checkingRequestOffre ||
                        (checkingRequestOffre &&
                          checkingRequestOffre.type === 'product'))
                    "
                    class="flex items-center mt-4"
                  >
                    <span
                      v-if="checkingRequestOffre && checkingRequestOffre.status"
                    >
                      <template
                        v-if="checkingRequestOffre.status === 'approved'"
                      >
                        <div class="flex items-center text-green-600">
                          <Icon icon="mdi:check-circle" class="mr-2 text-xl" />
                          <span>Vous êtes déjà demandé ce produit.</span>
                        </div>
                      </template>

                      <template
                        v-if="checkingRequestOffre.status === 'rejected'"
                      >
                        <div class="flex items-center text-red-600">
                          <Icon
                            icon="mdi:alert-triangle"
                            class="mr-2 text-xl"
                          />
                          <span
                            >Vous n'êtes pas autorisé à demander ce
                            produit.</span
                          >
                        </div>
                      </template>

                      <template
                        v-if="checkingRequestOffre.status === 'pending'"
                      >
                        <div class="flex items-center text-amber-600">
                          <Icon icon="mdi:minus-box" class="mr-2 text-xl" />
                          <span>Produit encore de validation.</span>
                        </div>
                      </template>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Description Section -->
        <div class="mt-10">
          <h2 class="text-lg font-semibold text-slate-800 mb-2">Description</h2>
          <div class="prose max-w-none">
            <div class="inner-html overflow-y-auto max-h-96">
              <span v-html="formData.description"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      loading: false,
      loadingOffre: false,
      fullPage: false,
      formData: {
        seller: {},
        type: "",
        details: [],
      },
      checkingRequestOffre: null,
      currentSettings: { info: { currency: "" } },
      currentSettingsGlobal: { info: { currency: "" } },
    };
  },
  async mounted() {
    this.currentSettings = this.$store.state.settings.find(
      (el) => el.country === this.idWharhouse.country
    );
    this.currentSettingsGlobal=this.$store.state.settings;
    if (this.$route.params.id) {
      const { content: data } = await this.$server.get("products", {
        id: this.$route.params.id,
        type: "marketplace",
      });
      console.log("data-------", data);
      if (!data || (data && data.type !== "marketplace"))
        return this.$toast.warning(
          "Une erreur c'est produit, ce produit c'est un produit de marketplace"
        );
      this.formData = data;
      if (this.currentUser.type === "Seller") {
        const { content: dataOffre } = await this.$server.get("marketplaces", {
          product: this.$route.params.id,
          type: 'product',
          notPopulate: true,
        });
        if (dataOffre && dataOffre._id) this.checkingRequestOffre = dataOffre;
        console.log("dataOffre-------", dataOffre);
      }
    }
  },
  computed: {},
  methods: {
    getPrice(datas){
       let price=0;

       if(datas.length>0){
           const conversion= this.$f.getSettingByCountry(this.currentSettingsGlobal,datas[0].country);
           const conversionWarehouseDefault= this.$f.getSettingByCountry(this.currentSettingsGlobal,this.idWharhouse.country);

          // price = Math.trunc(datas.length === 1 ? datas[0].priceMarket : parseInt((datas[0].priceMarket) / conversion.info.currencyUSD) * conversionWarehouseDefault.info.currencyUSD);
         // price = Math.trunc(datas[0].priceMarket);

          const groups = {};

          datas.forEach(({ country , priceMarket }) => {
            if (!groups[priceMarket]) {
              groups[priceMarket] = { priceMarket, countries: [] };
            }
            groups[priceMarket].countries.push({ country });
          });

          price= Object.values(groups);
       }

       return price;
    },
    RouterBack: function () {
      this.$router.back();
    },
    Copy(text) {
      console.log("text");
      const vm = this;
      this.$copyText(text).then(
        function (e) {
          vm.$toast.success("Copied");
          console.log(e);
        },
        function (e) {
          vm.$toast.warning("Can not copy");
          console.log(e);
        }
      );
    },
    generaterefLink(link, country) {
      if (link) {
        if (link.substring(link.length - 1) == "/")
          link = link.substring(0, link.length - 1);
        link += `?codinafrica=${this.currentUser.api.ref}-${this.checkingRequestOffre.productObject.id_v2||this.checkingRequestOffre.productObject.id}-${country}`;
        return link;
      } else return "";
    },
    async RequestOffre() {
      this.$confirm("Êtes-vous sûr de demander cette offre ?").then(
        async (res) => {
          if (res) {
            this.loadingOffre = true;
            const { content: dataAffiliate } = await this.$server.create(
              "marketplaces",
              this.formData
            );
            this.loadingOffre = false;
            console.log("dataAffiliate---------", dataAffiliate);
            if (dataAffiliate && dataAffiliate._id) {
              this.checkingRequestOffre = dataAffiliate;
              return this.$toast.success(
                "Votre demande a ete envoyé avec succès"
              );
            } else return this.$toast.warning(dataAffiliate);
          }
        }
      );
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async getSourcingsHistories() {
      const res = await this.$server.search("sourcingsHistories", {
        sourcing: this.$route.params.id,
      });
      if (res.content.results) {
        this.sourcingsHistories = res.content.results;
        this.sourcingsHistories.total = res.content.total;
        this.sourcingsHistories.lastpage = res.content.last_page;
        this.sourcingsHistories.per_page = res.content.per_page;
        this.sourcingsHistories.currentpage = res.content.current_page;
      } else this.sourcingsHistories = [];
    },
    async paginatation(direction) {
      let page = 0;

      if (
        direction === "next" &&
        this.paginate.currentpage < this.paginate.lastpage
      ) {
        page = ++this.paginate.currentpage;
      } else if (direction === "prev" && this.paginate.currentpage > 1) {
        page = --this.paginate.currentpage;
      } else if (
        direction.type === "goto" &&
        direction.page >= 1 &&
        direction.page <= this.paginate.lastpage
      ) {
        page = this.paginate.currentpage = direction.page;
      }

      const filters = {
        page: page,
        limit: this.limit,
      };

      this.getSourcingsHistories(filters);
    },
  },
};
</script>
